import AuthController from '../services/AuthController.js';
import { requireRouteCapability } from './routeCapability.js';
import { magnetOverviewEnabled, rememberMagnetHomeReturn, clearMagnetHomeReturn } from './magnetOverview.js';
import PubSub from 'pubsub-js';
import AppBroadcast from '../../../../shared/appBroadcast.js';

export function registerMagnetOverviewRoutes(router, { checkRouteAccess }) {
  let generation = 0;
  async function load(match, section = 'overview') {
    const ticket = ++generation;
    const hash = `#/${match.url.replace(/^\//, '')}`;
    const org = AuthController.getStoredActiveOrg();
    await Promise.resolve();
    const current = () => ticket === generation && location.hash === hash && org === AuthController.getStoredActiveOrg();
    if (!current()) return;
    if (!checkRouteAccess('home')) { rememberMagnetHomeReturn(hash); router.navigate('/signin'); return; }
    if (!magnetOverviewEnabled()) { router.navigate('/magnets'); return; }
    try {
      const scope = await AuthController.fetchScope();
      if (!current()) return;
      if (!checkRouteAccess('home')) { rememberMagnetHomeReturn(hash); router.navigate('/signin'); return; }
      if (!scope || (org && scope.activeOrg?.guid !== org)) throw new Error('This workspace could not be confirmed. Return to Your Magnets and try again.');
      if (!requireRouteCapability('/magnets')) return;
      PubSub.publish(AppBroadcast.ROUTE_NAV_BEFORE, { route: 'magnets' });
      const module = await import('../routes/magnet-overview-route.js');
      if (!current()) return;
      clearMagnetHomeReturn();
      await module.mountMagnetHome(document.getElementById('app'), match.data.guid, section);
      if (current()) PubSub.publish(AppBroadcast.ROUTE_NAV_AFTER, { route: 'magnets' });
    } catch (error) {
      if (!current()) return;
      const message = document.createElement('p'); message.setAttribute('role', 'alert'); message.textContent = error.message;
      const back = document.createElement('a'); back.href = '#/magnets'; back.textContent = 'Back to magnets';
      document.getElementById('app').replaceChildren(message, back);
    }
  }
  router.on('/magnets/:guid/website', match => load(match, 'website'));
  router.on('/magnets/:guid/results', match => load(match, 'results'));
  router.on('/magnets/:guid', match => {
    if (['new', 'drafts', 'archived'].includes(match.data.guid)) return;
    return load(match);
  });
}
